export default __webpack_public_path__ + "media/zurb/img/home/McAfee-01eeb2037f4292a88de7f5640d6f09a9.svg";